package team.platforma.multiplatform_material_extension.ui.email

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.intl.Locale
import androidx.compose.ui.text.intl.LocaleList
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import materialextension.multiplatform_material_extension.generated.resources.Res
import materialextension.multiplatform_material_extension.generated.resources.ic24_mel_exit_circle
import materialextension.multiplatform_material_extension.generated.resources.mel_ic_clear
import team.platforma.multiplatform_material_extension.ui.core.InputField
import team.platforma.multiplatform_material_extension.ui.core.InputFieldProperties
import team.platforma.multiplatform_material_extension.ui.core.InputFieldStateListener
import team.platforma.multiplatform_material_extension.ui.core.StyledTextField
import team.platforma.multiplatform_material_extension.ui.core.field_utils.endIcon
import team.platforma.multiplatform_material_extension.ui.core.global_style.area.supportArea
import team.platforma.multiplatform_material_extension.ui.core.global_style.setFiledTextFieldDefaults
import team.platforma.multiplatform_material_extension.ui.core.global_style.setOutlinedTextFieldDefaults
import team.platforma.multiplatform_material_extension.ui.core.global_style.shape.setFilledTextFieldDefaultShape
import team.platforma.multiplatform_material_extension.ui.core.global_style.shape.setOutlineTextFieldDefaultShape
import team.platforma.multiplatform_material_extension.ui.core.rememberInputFieldState
import team.platforma.multiplatform_material_extension.util.forms.FormProperties
import team.platforma.multiplatform_material_extension.util.forms.keyListener
import team.platforma.multiplatform_material_extension.util.forms.rememberForms
@Deprecated("")
object EmailField : InputField {

    @Composable
    fun create(
        email: String?,
        onEmailChange: (change: String) -> Unit,
        modifier: Modifier? = null,
        required: Boolean = true,
        formProperties: FormProperties? = null,
        error: Boolean = false,
        message: String = "",
        inputMessages: EmailInputMessages = EmailInputMessages()
    ): StyledTextField {

        val form by rememberForms()

        val mForm = formProperties ?: FormProperties(form, key = "")

        LaunchedEffect(mForm.key) {
            mForm.form.initValue(mForm.key, email ?: "")
            mForm.form.changeValue(mForm.key, email ?: "")
        }


       return builder(
            EmailFieldImpl(
                email = email,
                onEmailChange = { change ->
                    onEmailChange(change)
                },
                modifier = modifier,
                required = required,
                form = mForm,
                error = error,
                message = message,
                inputMessages = inputMessages
            )
        )
    }

    override fun builder(textFieldImpl: StyledTextField): StyledTextField = textFieldImpl

}

@Composable
private fun EmailFieldImpl(
    email: String?,
    onEmailChange: (change: String) -> Unit,
    modifier: Modifier?,
    required: Boolean,
    form: FormProperties,
    error: Boolean,
    message: String,
    inputMessages: EmailInputMessages
): StyledTextField {
    val inputFieldState = rememberInputFieldState()

    val focusRequester = remember { FocusRequester() }
    val index = remember { form.form.registerFocus(focusRequester) }

    var mEmail by remember { mutableStateOf(email ?: "") }

    var isError by remember { mutableStateOf(false) }

    LaunchedEffect(error) {
        isError = error
    }

    var helpMessage by remember { mutableStateOf("") }

    LaunchedEffect(message) {
        helpMessage = message
    }


    var showEndIcon by remember { mutableStateOf(false) }

    LaunchedEffect(mEmail) {
        showEndIcon = mEmail.isNotEmpty()
    }


    val enEmail = Regex("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}\$")
    val ruEmail = Regex("[а-яА-Я0-9._%+-]+@[а-яА-Я0-9.-]+\\.[а-яА-Я]{2,}\$")

    LaunchedEffect(Unit) {
        if (required) {
            if (mEmail.isNotEmpty()) {
                form.form.setValidateState(form.key, enEmail.matches(mEmail) || ruEmail.matches(mEmail))
            } else {
                form.form.setValidateState(form.key, false)

            }
        } else {
            if (mEmail.isNotEmpty()) {
                form.form.setValidateState(form.key, enEmail.matches(mEmail) || ruEmail.matches(mEmail))
            } else {
                form.form.setValidateState(form.key, true)
            }
        }
    }

    val coroutineScope = rememberCoroutineScope()

    DisposableEffect(inputFieldState) {

        val listener = object : InputFieldStateListener {

            override fun onEndIconClick() {
                coroutineScope.launch {
                    while (mEmail.isNotEmpty()) {
                        mEmail = mEmail.dropLast(1)
                        delay(15)
                    }

                    if (required) {
                        helpMessage = inputMessages.onFieldClear
                        isError = true
                    } else {
                        helpMessage = ""
                        isError = false
                    }
                    if (required) {
                        form.form.setValidateState(form.key, false)
                    } else {
                        form.form.setValidateState(form.key, true)
                    }
                    form.form.changeValue(form.key, "")
                    onValueChange("")
                }
            }


            override fun onValueChange(string: String) {
                mEmail = string
                onEmailChange(mEmail)
                form.form.changeValue(form.key, mEmail)

                val russianLetters = Regex("[а-яА-ЯёЁ]").findAll(string).count()
                val englishLetters = Regex("[a-zA-Z]").findAll(string).count()

                if (required) {
                    if (mEmail.isNotEmpty()) {
                        val valid = enEmail.matches(mEmail) || ruEmail.matches(mEmail)
                        form.form.setValidateState(form.key, valid)
                        isError = false
                        if (valid) {
                            helpMessage = ""
                        } else {
                           val uiMessage = when {
                               russianLetters > englishLetters -> inputMessages.ruInputMessage
                               englishLetters > russianLetters -> inputMessages.enInputMessage
                               else -> inputMessages.enInputMessage
                            }
                            helpMessage = uiMessage
                        }

                    } else {
                        form.form.setValidateState(form.key, false)
                        isError = true
                        helpMessage = inputMessages.onFieldClear
                    }
                } else {
                    if (mEmail.isNotEmpty()) {
                        val valid = enEmail.matches(mEmail) || ruEmail.matches(mEmail)
                        form.form.setValidateState(form.key, valid)
                        isError = false
                        if (valid) {
                            helpMessage = ""
                        } else {
                            val uiMessage = when {
                                russianLetters > englishLetters -> inputMessages.ruInputMessage
                                englishLetters > russianLetters -> inputMessages.enInputMessage
                                else -> inputMessages.enInputMessage
                            }
                            helpMessage = uiMessage
                        }
                    } else {
                        form.form.setValidateState(form.key, true)
                        isError = false
                        helpMessage = ""

                    }
                }
            }
        }

        inputFieldState.addListener(listener)

        onDispose {
            inputFieldState.removeListener(listener)
        }
    }

    return object : StyledTextField {

        @Composable
        override fun Outline(properties: InputFieldProperties?) {
            Column(
                modifier = (modifier ?: Modifier).width(IntrinsicSize.Min)
            ) {
                OutlinedTextField(
                    value = mEmail,
                    onValueChange = { change ->
                        inputFieldState.changeValue(change.trim())
                    },
                    trailingIcon = {
                        if (showEndIcon) {
                            endIcon(
                                drawableResource = properties?.endIcon
                                    ?: Res.drawable.ic24_mel_exit_circle,
                                inputFieldState = inputFieldState
                            )
                        }
                    },

                    label = properties?.label,
                    placeholder = properties?.placeholder,
                    keyboardOptions = KeyboardOptions.Default.copy(
                        keyboardType = KeyboardType.Email,
                        hintLocales = LocaleList(Locale("en"))
                    ),
                    modifier = (properties?.modifier ?: Modifier)
                        .keyListener(Key.Tab) {
                            form.form.moveToNextFocus(index)
                        }.focusRequester(focusRequester),
                    shape = properties?.shape ?: setOutlineTextFieldDefaultShape(),
                    colors = properties?.colors ?: setOutlinedTextFieldDefaults(),
                    isError = isError
                )
                Column(
                    modifier = Modifier.heightIn(min = supportArea()).fillMaxWidth()
                ) {
                    AnimatedVisibility(helpMessage.isNotEmpty()) {
                        val helperTextColors = properties?.colors ?: setOutlinedTextFieldDefaults()
                        Text(
                            modifier = Modifier.padding(horizontal = 16.dp),
                            text = helpMessage,
                            color = if (isError) helperTextColors.errorSupportingTextColor else helperTextColors.focusedSupportingTextColor,
                            style = MaterialTheme.typography.bodySmall
                        )
                    }
                }
            }
        }

        @Composable
        override fun Filled(properties: InputFieldProperties?) {
            Column(
                modifier = (modifier ?: Modifier).width(IntrinsicSize.Min)
            ) {
                TextField(
                    value = mEmail,
                    onValueChange = { change ->
                        inputFieldState.changeValue(change.trim())
                    },
                    trailingIcon = {
                        if (showEndIcon) {
                            endIcon(
                                drawableResource = properties?.endIcon
                                    ?: Res.drawable.ic24_mel_exit_circle,
                                inputFieldState = inputFieldState
                            )
                        }
                    },

                    label = properties?.label,
                    placeholder = properties?.placeholder,
                    keyboardOptions = KeyboardOptions.Default.copy(
                        keyboardType = KeyboardType.Email,
                        hintLocales = LocaleList(Locale("en"))
                    ),
                    modifier = (properties?.modifier ?: Modifier)
                        .keyListener(Key.Tab) {
                            form.form.moveToNextFocus(index)
                        }.focusRequester(focusRequester),
                    shape = properties?.shape ?: setFilledTextFieldDefaultShape(),
                    colors = properties?.colors ?: setFiledTextFieldDefaults(),
                    isError = isError
                )
                Column(
                    modifier = Modifier.heightIn(min = supportArea()).fillMaxWidth()
                ) {
                    AnimatedVisibility(helpMessage.isNotEmpty()) {
                        val helperTextColors = properties?.colors ?: setFiledTextFieldDefaults()
                        Text(
                            modifier = Modifier.padding(horizontal = 16.dp),
                            text = helpMessage,
                            color = if (isError) helperTextColors.errorSupportingTextColor else helperTextColors.focusedSupportingTextColor,
                            style = MaterialTheme.typography.bodySmall
                        )
                    }
                }
            }
        }

    }
}